/**
 * VENSSLIM™ — FINDGEAR MAX
 * Premium Product Page JavaScript
 * Compatible Shopify OS 2.0
 */

(function () {
  'use strict';

  /* ============================================================
     GALLERY MANAGER
     ============================================================ */
  class VensSlimGallery {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.vs-gallery__slide');
      this.thumbs = container.querySelectorAll('.vs-gallery__thumb');
      this.dots = container.querySelectorAll('.vs-gallery__dot');
      this.track = container.querySelector('.vs-gallery__track');
      this.mainImg = container.querySelector('.vs-gallery__main');
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;

      this.init();
    }

    init() {
      // Thumbnail clicks
      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.goTo(i));
      });

      // Dot clicks
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      // Touch swipe
      if (this.track) {
        this.track.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].clientX;
        }, { passive: true });

        this.track.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].clientX;
          this.handleSwipe();
        }, { passive: true });
      }

      // Lightbox
      const zoomBtn = this.container.querySelector('.vs-gallery__zoom-btn');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', () => this.openLightbox());
      }
    }

    goTo(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.currentIndex = index;

      // Update track
      if (this.track) {
        this.track.style.transform = `translateX(-${index * 100}%)`;
      }

      // Update thumbs
      this.thumbs.forEach((t, i) => {
        t.classList.toggle('vs-active', i === index);
      });

      // Update dots
      this.dots.forEach((d, i) => {
        d.classList.toggle('vs-active', i === index);
      });
    }

    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) this.goTo(this.currentIndex + 1);
        else this.goTo(this.currentIndex - 1);
      }
    }

    openLightbox() {
      const lightbox = document.querySelector('.vs-lightbox');
      if (!lightbox) return;
      const activeSlide = this.slides[this.currentIndex];
      const img = activeSlide ? activeSlide.querySelector('img') : null;
      const lbImg = lightbox.querySelector('img');
      if (img && lbImg) lbImg.src = img.src;
      lightbox.classList.add('vs-open');
      document.body.style.overflow = 'hidden';
    }

    updateImages(imageUrls) {
      this.slides.forEach((slide, i) => {
        const img = slide.querySelector('img');
        if (img && imageUrls[i]) {
          img.src = imageUrls[i];
          img.srcset = '';
        }
      });
      this.thumbs.forEach((thumb, i) => {
        const img = thumb.querySelector('img');
        if (img && imageUrls[i]) {
          img.src = imageUrls[i];
          img.srcset = '';
        }
      });
      this.goTo(0);
    }
  }

  /* ============================================================
     VARIANT SELECTOR
     ============================================================ */
  class VensSlimVariants {
    constructor(container) {
      this.container = container;
      this.productData = null;
      this.selectedOptions = {};
      this.currentVariant = null;

      this.init();
    }

    init() {
      // Load product JSON
      const productDataEl = document.getElementById('vs-product-data');
      if (productDataEl) {
        try {
          this.productData = JSON.parse(productDataEl.textContent);
          this.initSelectedOptions();
        } catch (e) {
          console.warn('VenSlim: Could not parse product data');
        }
      }

      // Bind option buttons
      this.container.querySelectorAll('.vs-variant-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const option = btn.dataset.option;
          const value = btn.dataset.value;
          this.selectOption(option, value, btn);
        });
      });
    }

    initSelectedOptions() {
      if (!this.productData) return;
      const firstVariant = this.productData.variants[0];
      if (!firstVariant) return;

      this.productData.options.forEach((opt, i) => {
        this.selectedOptions[opt] = firstVariant[`option${i + 1}`];
      });

      // Mark initial selection
      this.container.querySelectorAll('.vs-variant-btn').forEach(btn => {
        const opt = btn.dataset.option;
        const val = btn.dataset.value;
        if (this.selectedOptions[opt] === val) {
          btn.classList.add('vs-selected');
        }
      });

      this.updateVariant();
    }

    selectOption(option, value, btn) {
      // Update selected state for this option group
      this.container.querySelectorAll(`[data-option="${option}"]`).forEach(b => {
        b.classList.remove('vs-selected');
      });
      btn.classList.add('vs-selected');

      this.selectedOptions[option] = value;
      this.updateVariant();
    }

    updateVariant() {
      if (!this.productData) return;

      const variant = this.findVariant();
      this.currentVariant = variant;

      if (variant) {
        this.updatePrice(variant);
        this.updateAvailability(variant);
        this.updateVariantInput(variant);
        this.updateStickyPrice(variant);

        // Update gallery if variant has featured image
        if (variant.featured_image) {
          const gallery = document.querySelector('.vs-gallery');
          if (gallery && gallery._gallery) {
            // gallery._gallery.updateImages([variant.featured_image.src]);
          }
        }
      }
    }

    findVariant() {
      if (!this.productData) return null;
      return this.productData.variants.find(variant => {
        return this.productData.options.every((opt, i) => {
          return variant[`option${i + 1}`] === this.selectedOptions[opt];
        });
      }) || null;
    }

    updatePrice(variant) {
      const priceEl = document.querySelector('.vs-price-current');
      const origEl = document.querySelector('.vs-price-original');
      const savingsEl = document.querySelector('.vs-price-savings');

      if (priceEl) {
        priceEl.textContent = this.formatMoney(variant.price);
      }
      if (origEl && variant.compare_at_price > variant.price) {
        origEl.textContent = this.formatMoney(variant.compare_at_price);
        origEl.style.display = '';
        const saved = variant.compare_at_price - variant.price;
        if (savingsEl) {
          savingsEl.textContent = `✓ Vous économisez ${this.formatMoney(saved)}`;
        }
      }
    }

    updateAvailability(variant) {
      const atcBtn = document.querySelector('.vs-atc-btn');
      const stickyBtn = document.querySelector('.vs-sticky-atc__btn');

      if (!variant || !variant.available) {
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.innerHTML = '<span>Rupture de stock</span>';
        }
        if (stickyBtn) {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'Rupture de stock';
        }
      } else {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.innerHTML = `
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <span>Ajouter au panier</span>`;
        }
        if (stickyBtn) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'Ajouter au panier';
        }
      }
    }

    updateVariantInput(variant) {
      const input = document.querySelector('[name="id"]');
      if (input) input.value = variant.id;
    }

    updateStickyPrice(variant) {
      const stickyPrice = document.querySelector('.vs-sticky-atc__price');
      if (stickyPrice && variant) {
        stickyPrice.innerHTML = `${this.formatMoney(variant.price)}<s class="vs-sticky-atc__price-original">${this.formatMoney(variant.compare_at_price)}</s>`;
      }
    }

    formatMoney(cents) {
      return (cents / 100).toLocaleString('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
    }
  }

  /* ============================================================
     ADD TO CART
     ============================================================ */
  class VensSlimCart {
    constructor() {
      this.init();
    }

    init() {
      // Main ATC button
      const atcBtn = document.querySelector('.vs-atc-btn[data-action="add-to-cart"]');
      if (atcBtn) {
        atcBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart(atcBtn);
        });
      }

      // Sticky ATC button
      const stickyBtn = document.querySelector('.vs-sticky-atc__btn');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          const mainBtn = document.querySelector('.vs-atc-btn[data-action="add-to-cart"]');
          if (mainBtn) this.addToCart(mainBtn);
        });
      }
    }

    async addToCart(btn) {
      const variantId = document.querySelector('[name="id"]')?.value;
      const qty = parseInt(document.querySelector('.vs-qty-input')?.value || '1');

      if (!variantId) {
        alert('Veuillez sélectionner une taille');
        return;
      }

      // Loading state
      btn.classList.add('vs-loading');
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<div class="vs-spinner"></div><span>Ajout en cours...</span>';
      btn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });

        if (!response.ok) throw new Error('Cart error');

        const data = await response.json();

        // Success animation
        btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span>Ajouté !</span>`;
        btn.style.background = '#16A34A';

        // Update cart count
        this.updateCartCount();

        // Show cart drawer or redirect
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.style.background = '';
          btn.disabled = false;
          btn.classList.remove('vs-loading');

          // Try to open cart drawer if theme supports it
          document.dispatchEvent(new CustomEvent('cart:open'));

          // If no drawer, animate cart icon
          const cartIcon = document.querySelector('.cart-count-bubble, .cart-notification, [data-cart-count]');
          if (cartIcon) {
            cartIcon.classList.add('cart-updated');
            setTimeout(() => cartIcon.classList.remove('cart-updated'), 600);
          }
        }, 1800);

      } catch (error) {
        btn.innerHTML = '<span>Erreur — Réessayez</span>';
        btn.style.background = '#DC2626';
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.style.background = '';
          btn.disabled = false;
          btn.classList.remove('vs-loading');
        }, 2500);
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const countEls = document.querySelectorAll('[data-cart-count], .cart-count-bubble');
        countEls.forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.style.display = '';
        });
      } catch (e) {}
    }
  }

  /* ============================================================
     QUANTITY SELECTOR
     ============================================================ */
  class VensSlimQuantity {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.vs-qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const input = btn.closest('.vs-qty-selector')?.querySelector('.vs-qty-input');
          if (!input) return;
          let val = parseInt(input.value) || 1;
          if (btn.dataset.action === 'increase') val = Math.min(val + 1, 10);
          if (btn.dataset.action === 'decrease') val = Math.max(val - 1, 1);
          input.value = val;
          this.onQtyChange(val);
        });
      });

      document.querySelectorAll('.vs-qty-input').forEach(input => {
        input.addEventListener('change', () => {
          let val = parseInt(input.value) || 1;
          val = Math.max(1, Math.min(10, val));
          input.value = val;
          this.onQtyChange(val);
        });
      });
    }

    onQtyChange(qty) {
      // Update bundle selection if applicable
      const bundleOptions = document.querySelectorAll('.vs-bundle__option');
      if (bundleOptions.length) {
        bundleOptions.forEach(opt => {
          if (parseInt(opt.dataset.qty) === qty) {
            bundleOptions.forEach(o => o.classList.remove('vs-selected'));
            opt.classList.add('vs-selected');
          }
        });
      }
    }
  }

  /* ============================================================
     BUNDLE SELECTOR
     ============================================================ */
  class VensSlimBundle {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.vs-bundle__option').forEach(option => {
        option.addEventListener('click', () => {
          document.querySelectorAll('.vs-bundle__option').forEach(o => o.classList.remove('vs-selected'));
          option.classList.add('vs-selected');

          const qty = parseInt(option.dataset.qty) || 1;
          const qtyInput = document.querySelector('.vs-qty-input');
          if (qtyInput) {
            qtyInput.value = qty;
          }
        });
      });
    }
  }

  /* ============================================================
     STICKY ATC
     ============================================================ */
  class VensSlimStickyATC {
    constructor() {
      this.stickyBar = document.querySelector('.vs-sticky-atc');
      this.mainATC = document.querySelector('.vs-atc-btn');
      this.observer = null;
      this.init();
    }

    init() {
      if (!this.stickyBar || !this.mainATC) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              this.stickyBar.classList.add('vs-visible');
            } else {
              this.stickyBar.classList.remove('vs-visible');
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -100px 0px' }
      );

      this.observer.observe(this.mainATC);
    }
  }

  /* ============================================================
     FAQ ACCORDION
     ============================================================ */
  class VensSlimFAQ {
    constructor() {
      this.init();
    }

    init() {
      document.querySelectorAll('.vs-faq__question').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.vs-faq__item');
          const isOpen = item.classList.contains('vs-open');

          // Close all
          document.querySelectorAll('.vs-faq__item.vs-open').forEach(i => {
            if (i !== item) i.classList.remove('vs-open');
          });

          // Toggle current
          item.classList.toggle('vs-open', !isOpen);
        });
      });

      // Open first item by default
      const firstItem = document.querySelector('.vs-faq__item');
      if (firstItem) firstItem.classList.add('vs-open');
    }
  }

  /* ============================================================
     COUNTDOWN TIMER
     ============================================================ */
  class VensSlimCountdown {
    constructor() {
      this.endTime = this.getEndTime();
      this.init();
    }

    getEndTime() {
      const stored = sessionStorage.getItem('vs_countdown_end');
      if (stored) return parseInt(stored);
      // 4 hours from now
      const end = Date.now() + (4 * 60 * 60 * 1000);
      sessionStorage.setItem('vs_countdown_end', end.toString());
      return end;
    }

    init() {
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = this.endTime - Date.now();

      if (remaining <= 0) {
        clearInterval(this.interval);
        // Reset for next session
        sessionStorage.removeItem('vs_countdown_end');
        const countdown = document.querySelector('.vs-countdown');
        if (countdown) countdown.style.display = 'none';
        return;
      }

      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

      const hoursEl = document.querySelector('[data-countdown="hours"]');
      const minutesEl = document.querySelector('[data-countdown="minutes"]');
      const secondsEl = document.querySelector('[data-countdown="seconds"]');

      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  /* ============================================================
     LIGHTBOX
     ============================================================ */
  class VensSlimLightbox {
    constructor() {
      this.init();
    }

    init() {
      const lightbox = document.querySelector('.vs-lightbox');
      if (!lightbox) return;

      const closeBtn = lightbox.querySelector('.vs-lightbox__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) this.close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    close() {
      const lightbox = document.querySelector('.vs-lightbox');
      if (lightbox) {
        lightbox.classList.remove('vs-open');
        document.body.style.overflow = '';
      }
    }
  }

  /* ============================================================
     MODAL (SIZE GUIDE)
     ============================================================ */
  class VensSlimModals {
    constructor() {
      this.init();
    }

    init() {
      // Open triggers
      document.querySelectorAll('[data-modal-open]').forEach(btn => {
        btn.addEventListener('click', () => {
          const target = document.getElementById(btn.dataset.modalOpen);
          if (target) {
            target.classList.add('vs-open');
            document.body.style.overflow = 'hidden';
          }
        });
      });

      // Close triggers
      document.querySelectorAll('[data-modal-close], .vs-modal__close').forEach(btn => {
        btn.addEventListener('click', () => {
          const overlay = btn.closest('.vs-modal-overlay');
          if (overlay) {
            overlay.classList.remove('vs-open');
            document.body.style.overflow = '';
          }
        });
      });

      // Click outside
      document.querySelectorAll('.vs-modal-overlay').forEach(overlay => {
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) {
            overlay.classList.remove('vs-open');
            document.body.style.overflow = '';
          }
        });
      });
    }
  }

  /* ============================================================
     SCROLL ANIMATIONS
     ============================================================ */
  class VensSlimAnimations {
    constructor() {
      this.init();
    }

    init() {
      if (!('IntersectionObserver' in window)) return;

      const animateEls = document.querySelectorAll(
        '.vs-benefit-card, .vs-step, .vs-review-card, .vs-faq__item, .vs-proof-stat'
      );

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                entry.target.classList.add('vs-animate-in');
              }, i * 80);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );

      animateEls.forEach(el => {
        el.style.opacity = '0';
        observer.observe(el);
      });
    }
  }

  /* ============================================================
     NUMBER COUNTER ANIMATION
     ============================================================ */
  function animateCounter(el, target, duration = 1500, suffix = '') {
    const start = performance.now();
    const startVal = 0;

    function update(time) {
      const elapsed = time - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(startVal + (target - startVal) * eased);
      el.textContent = current.toLocaleString('fr-FR') + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  function initCounters() {
    const counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.dataset.counter);
          const suffix = el.dataset.counterSuffix || '';
          animateCounter(el, target, 1500, suffix);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(el => observer.observe(el));
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    // Gallery
    const galleryContainer = document.querySelector('.vs-gallery');
    if (galleryContainer) {
      const gallery = new VensSlimGallery(galleryContainer);
      galleryContainer._gallery = gallery;
    }

    // Variants
    const productInfo = document.querySelector('.vs-product-info');
    if (productInfo) {
      new VensSlimVariants(productInfo);
    }

    // Cart
    new VensSlimCart();

    // Quantity
    new VensSlimQuantity();

    // Bundle
    new VensSlimBundle();

    // Sticky ATC
    new VensSlimStickyATC();

    // FAQ
    new VensSlimFAQ();

    // Countdown
    if (document.querySelector('.vs-countdown')) {
      new VensSlimCountdown();
    }

    // Lightbox
    new VensSlimLightbox();

    // Modals
    new VensSlimModals();

    // Animations
    new VensSlimAnimations();

    // Counters
    initCounters();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
